module.exports = __webpack_public_path__ + "img/travel.44f0f8a6.svg";